import { Action } from 'helpers/action-helpers';
import { AppState } from 'pages/app/state';
import { CertaMenu, ConnectedProps, ActionProps } from './component';
import { CloseMobileMenuAction, SetMenuOperationAction } from './actions';
import { connect, Dispatch } from 'react-redux';
import { withRouter } from 'react-router';
import { NmvsMenuItem } from 'types/nmvs-menu-item';
import { currentOperationSelector } from './selectors';
import { tenantSelector } from 'pages/settings/selectors';
import { connectionSelector } from 'components/connection-status/selectors';
import { permissionsSelector } from 'pages/login/selectors';

const mapStateToProps = (state: AppState): ConnectedProps => {
  return {
    currentOperation: currentOperationSelector(state),
    operations: state.menu.operations,
    permissions: permissionsSelector(state),
    isOnline: connectionSelector(state),
    language: tenantSelector(state).language
  };
};

function mapDispatchToProps(dispatch: Dispatch<Action>): ActionProps {
  return {
    selectOperation: (menuOperation: NmvsMenuItem) => dispatch(new SetMenuOperationAction(menuOperation)),
    closeMenu: () => dispatch(new CloseMobileMenuAction())
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CertaMenu));


// WEBPACK FOOTER //
// ./src/components/menu/index.ts